import React from 'react';

import { BookSortingEnum } from '~/api/book/bookApiTypes';
import { PostLink } from '~/atomic/atom/links/dynamicLinks';
import { getBooks } from '~/atomic/page/catalog/tagPage/tagPage.data';
import { tagFiltersSelector } from '~/atomic/page/catalog/tagPage/tagPage.selector';
import { Contest } from '~/atomic/page/contest/Contest';
import { catalogFilterActions } from '~/feature/catalog/filter/catalogFilter.slice';
import { paginationActions } from '~/feature/pagination/pagination.slice';
import { useAppDispatch, useAppSelector } from '~/store';

export const CONTEST_DUKE_RECTOR_TWO_DRAGONS_TAG_SLUG = 'eksmoflr1';

export const ContestZhenitNelzyaPomilovat = () => {
  const dispatch = useAppDispatch();
  const { books, isLoadBooks } = useAppSelector(tagFiltersSelector);

  const onLoadBooks = () => {
    dispatch(paginationActions.setPageSize({ perPage: 100 }));
    dispatch(catalogFilterActions.setTagSlug(CONTEST_DUKE_RECTOR_TWO_DRAGONS_TAG_SLUG));
    dispatch(getBooks());
  };

  const onLoadSidebarBooks = () => {
    dispatch(paginationActions.setPageSize({ perPage: 6 }));
    dispatch(catalogFilterActions.setBookSorting(BookSortingEnum.Rand));
    dispatch(catalogFilterActions.setTagSlug(CONTEST_DUKE_RECTOR_TWO_DRAGONS_TAG_SLUG));
    dispatch(getBooks());
  };

  return (
    <Contest
      bannerProps={{ bannerSrc: 'https://storage.bookriver.ru/storage/banners/zhenitnelzyapomilovat.jpg' }}
      commentProps={{
        targetId: 6385, // заменить на идентификатор новости
        targetAuthorId: String(1493),
      }}
      contestBooksProps={{
        books,
        isLoading: isLoadBooks,
        onLoadBooks,
        description: 'Конкурс фэнтезийных любовных романов «Женить нельзя помиловать»!',
      }}
      contestSidebarBooksProps={{
        books,
        isLoading: isLoadBooks,
        onLoadBooks: onLoadSidebarBooks,
      }}
      contestResults={{
        winnerBookSlugs: ['alyona-cvetkova-svakha-aferistka-dlya-besa'],
        secondPlace: [],
        thirdPlace: [],
        shortList: [],
      }}
      descriptionProps={{
        content: (
          <>
            <p style={{
              textAlign: 'center',
              color: 'var(--green2-color)',
              fontSize: '18px',
              marginBottom: '16px',
            }}
            >
              Прием заявок окончен. Идет работа жюри.
            </p>
            <p style={{ textAlign: 'center' }}>
              <b>
                По просьбе жюри сроки оглашения победителей
                сдвигаются на конец января (25-30 числа)
              </b>
            </p>
            <p>
              <span>
                «Bookriver» совместно с издательским домом «АСТ» проводит конкурс фэнтезийных любовных романов
              </span>
              <b> «Женить нельзя помиловать»!</b>
            </p>
            <p>
              <span>
                Тематика конкурса: «Профессия: сваха».
              </span>
            </p>
            <p>
              <span>
                Про отчаянно-смелых и креативных работников брачных агентств, свах, обаятельных мерзавцах-свадебных аферистов (которые обязательно получат по заслугам!) и все это  — в антураже фэнтезийного мира.
              </span>
            </p>
            <p>
              <span>
                Мы ждем от вас легкие, веселые, наполненные юмором истории о том, как нелегко бывает найти свою любовь самому,  что даже приходится искать помощи настоящих профессионалов. Любовь может искать как главный герой\героиня, так и возможные клиенты брачного агентства\свахи.
              </span>
            </p>
            <p>
              <span>
                На конкурс принимаются работы, основным жанром которых является любовное фэнтези,  с возрастным ограничением 16+
              </span>
            </p>
            <p>
              <h3>Сроки проведения конкурса</h3>
            </p>
            <p>
              <b>Прием заявок:</b>
              <span> с 15.06.2024 г. по 20.12.2024 г. включительно.</span>
            </p>
            <p>
              <b>Работа жюри, формирование шорт-листа:</b>
              <span> с 21.12.2024 г. по 14.01.2025 г.</span>
            </p>
            <p>
              <b>Оглашение победителей:</b>
              <span> 15-17 января 2025 г.</span>
            </p>
            <p><i>Сроки могут быть изменены по решению организаторов.</i></p>
            <h3>Призы</h3>
            <p>
              <b>Заключение договора с «Эксмо» на издание бумажной* и аудио-книги.</b>
            </p>
            <p>
              <b>Издатель выберет несколько победителей в новую совместную межавторскую серию «Bookriver: Магия любви»</b>
            </p>
            <p>
              <span>Для всех попавших в шорт-лист, мы предоставим бесплатный месяц рекламы от портала на конкурсное произведение и персональный баннер на главной странице после оглашения победителей.</span>
            </p>
            <p>
              <span>* Книги будут издаваться в твердом переплете, на типографской бумаге. Издатель сохраняет за автором право оставить публикацию электронной книги на сайте «Bookriver» для дальнейшего продвижения и продажи лично автором.</span>
            </p>
            <p><h3>Выбор победителя</h3></p>
            <p>
              <b>Лонг-лист</b>
              <span> формируется на основании присланных участниками синопсисов.</span>
            </p>
            <p>
              <b>Шорт-лист</b>
              <span>
                {' '}
                формируется на основании литературно художественных достоинств текста,
                а так же — учитывается максимальное соответствие произведения тематике конкурса
                и читательский отклик (посещаемость, комментарии, библиотеки, покупки).
                В интересах автора вести читателя на страницу конкурсного романа, однако
                мы призываем не использовать накрутки — это будет строго отслеживаться,
                замеченные в нечестной игре будут сняты с конкурса.
              </span>
            </p>
            <p>
              <b>Жюри:</b>
              <span> команда Bookriver и ведущий редактор романтического фэнтези «Эксмо» Мария Руднева.</span>
            </p>
            <p><h3>Условия участия</h3></p>
            <p>
              <span>
                Конкурсное произведение должно быть эксклюзивным (не иметь публикаций на других площадках, кроме как на  Bookriver в объеме, не превышающем 1\4 от всего произведения) и оставаться таковым до объявления победителей.  Конкурсное произведение не должно распространяться бесплатно на постоянной основе. Наличие у произведения полноценной аннотации (не отрывка из текста книги!) обязательно.
              </span>
            </p>
            <p>
              <i>
                *После объявления победителей эксклюзив по желанию автора снимается. За авторами-победителями остаются все права на электронную (не аудио!) книгу, т.к издательство по договору с автором получает не эксклюзивные права на неё.
              </i>
            </p>
            <br />
            <p>
              <b>Жанр: </b>
              <span>
                Любовное фэнтези. Допускается наличие дополнительных жанров (например, детектив, боевое фэнтези и т.д). Наличие любовной линии (линий) и классический счастливый конец обязательны. Из аннотации должно быть четко ясно, что ваша книга связана с тематикой конкурса. Допустимо прислать на конкурс 1 том, как начало будущей серии (т.е работа не обязательно должна быть однотомником).
              </span>
            </p>
            <p>
              <b>Объем: </b>
              <span>
                от 320 000 до 480 000* знаков с пробелами, для завершенного произведения. Минимальный объем текста для подачи заявки — 80 000 знаков для романа, имеющего статус  «в процессе».
              </span>
            </p>
            <p>
              <i>*Издательство допускает незначительное превышение объема, если произведение соответствует всем основным критериям.</i>
            </p>
            <p>
              <b>Форма произведения: </b>
              <span>роман.</span>
            </p>
            <p>
              <b>Возрастной ценз:</b>
              <span> 16+</span>
            </p>
            <p>
              <b>Статус произведения на момент подачи заявки:</b>
              <span>
                «полностью» или «в процессе», с условием, что произведение будет выложено полностью до 21.12.2024 г.(до 00:00 21.12.2024 по МСК.) Все кто не успеет завершить свою работу до этого времени, будут сняты с конкурса.
              </span>
            </p>
            <p>
              <b>В конкурсных работах не должно быть:</b>
              <span>
                романов, продолжающих цикл; фанфиков по другим произведениям; текстов, содержащих огромное количество орфографических ошибок; произведений, содержание которых противоречит законодательству РФ; романов с рейтингом 18+
              </span>
            </p>
            <br />
            <p>
              <span>Заявка отправляется на почту </span>
              <a href="mailto:ads@bookriver.ru"><span>ads@bookriver.ru</span></a>
            </p>
            <p>
              <span>Тема письма: Женить нельзя помиловать</span>
            </p>
            <p>
              <span>Текст письма:</span>
              <ol>
                <li>Имя/псевдоним автора</li>
                <li>Название произведения</li>
                <li>Ссылку на произведение на Bookriver.</li>
              </ol>
            </p>
            <p>
              <span>
                Один автор может предложить только одну книгу!
              </span>
            </p>
            <p>
              <span>
                Соавторские работы закрепляются сразу за двумя авторами.
              </span>
            </p>
            <p>
              <span>После того, как ваша заявка будет принята, вам необходимо предоставить синопсис на произведение, </span>
              <b>сроком не позднее чем до 21.11.2024. </b>
            </p>
            <p>
              <span>Все заявки, поданные после этого срока, должны сразу содержать в себе синопсис, иначе будут отклонены.</span>
            </p>
            <p>
              <span>
                Синопсис в формате .doc или .docx
              </span>
            </p>
            <p>
              <span>Объем синопсиса до 10 000 знаков с пробелами. </span>
            </p>
            <p>
              <span>
                Название документа с синопсисом указывайте в формате «Автор — Название романа — синопсис».
              </span>
            </p>
            <p>
              <h3>
                О том, что такое синопсис, вы можете прочитать тут
                {' '}
                <PostLink slugPost="sinopsis--shpargalka-dlya-avtora-3394">
                  <a>
                    (ссылка на блог)
                  </a>
                </PostLink>
              </h3>
            </p>
          </>
        ),
      }}
    />
  );
};
